/* eslint-disable react-hooks/exhaustive-deps */
import { useLocation } from '@reach/router'
import React, { useEffect } from 'react'
import serverData from 'ppbl/utils/server-data'
import clientLogger from 'ppbl/utils/client-logger'
import { UTM_CAMPAIGN } from 'ppbl/utils/constants'
import { storeUtmCampaignDetails } from '../../../screens/__utils__.js'

/**
 * This is a functional component that handles campaign redirection of users
 * @returns {JSX.Element} - A JSX element
 */
const CampaignRedirection = () => {
  const location = useLocation()

  useEffect(() => {
    sessionStorage.setItem('ppbl_campaign_transition', 'true')
    clientLogger.info('Old Campaign URL flow')

    const queryParams = new URLSearchParams(location.search)
    const returnUrl = queryParams.get('returnUrl')

    const utmCampaignId = queryParams.get(UTM_CAMPAIGN)
    if (utmCampaignId) {
      storeUtmCampaignDetails(utmCampaignId)
    }

    if (returnUrl) {
      window.location.assign(decodeURIComponent(returnUrl))
    } else {
      window.location.assign(
        serverData.data.appConfig.application?.PPBLMarketingPage,
      )
    }
  }, [])

  return <></>
}

export default CampaignRedirection
